// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-step-upload-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    padding: 40px;
    max-width: 700px;
    margin: 50px auto;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.progress-indicator {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 30px;
    position: relative;
}

.step {
    flex: 1 1;
    text-align: center;
    position: relative;
    margin: 3px;
}

.step:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 20px;
    right: -50%;
    width: 100%;
    height: 2px;
    background-color: #ccc;
    z-index: -1;
}

.step:not(:first-child)::before {
    content: '';
    position: absolute;
    top: 20px;
    left: -50%;
    width: 100%;
    height: 2px;
    background-color: #ccc;
    z-index: -1;
}

.step.active::before,
.step.active::after {
    background-color: #144040;
    color: #dcca98;
}

.step-number {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #dcca98;
    color: #144040;
    font-weight: bold;
    margin-bottom: 10px;
}

.step.active .step-number {
    background-color: #144040;
    color: #dcca98;
}

.step-title {
    font-size: 14px;
    color: #555;
}

.step.active .step-title {
    color: #dcca98;
    font-weight: bold;
}

.upload-content {
    text-align: center;
    width: 100%;
}

.upload-content h2 {
    margin-bottom: 10px;
    color: #144040;
}

.upload-content p {
    margin-bottom: 20px;
    color: #555;
}

.file-input {
    width: 80%;
    padding: 12px;
    margin: 20px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.uploaded-file-info {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.uploaded-file-info p {
    margin-bottom: 10px;
    color: #144040;
}

.remove-file-button {
    background-color: #d9534f;
    color: #fff;
    border: none;
    padding: 8px 12px;
    border-radius: 5px;
    cursor: pointer;
}

.remove-file-button:hover {
    background-color: #c9302c;
}

.navigation-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 30px;
}

.primary-button,
.secondary-button {
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    font-size: 1em;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.primary-button {
    background-color: #144040;
    color: #fff;
}

.primary-button:hover {
    background-color: #0f2d2d;
}

.secondary-button {
    background-color: #dcca98;
    color: #144040;
}

.secondary-button:hover {
    background-color: #b89e74;
}

.completion-message {
    text-align: center;
}

.completion-message h2 {
    color: #28a745;
    margin-bottom: 10px;
}

.completion-message p {
    color: #555;
}

@media (max-width: 600px) {
    .multi-step-upload-container {
        padding: 20px;
    }

    .file-input {
        width: 100%;
    }

    .progress-indicator {
        flex-direction: column;
    }

    .step:not(:last-child)::after,
    .step:not(:first-child)::before {
        content: none;
    }

    .step {
        margin-bottom: 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/AutoGrader/MultiStepUploadPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,2DAA2D;AAC/D;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".multi-step-upload-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: auto;\n    padding: 40px;\n    max-width: 700px;\n    margin: 50px auto;\n    background: #ffffff;\n    border-radius: 12px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);\n    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n.progress-indicator {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 30px;\n    position: relative;\n}\n\n.step {\n    flex: 1;\n    text-align: center;\n    position: relative;\n    margin: 3px;\n}\n\n.step:not(:last-child)::after {\n    content: '';\n    position: absolute;\n    top: 20px;\n    right: -50%;\n    width: 100%;\n    height: 2px;\n    background-color: #ccc;\n    z-index: -1;\n}\n\n.step:not(:first-child)::before {\n    content: '';\n    position: absolute;\n    top: 20px;\n    left: -50%;\n    width: 100%;\n    height: 2px;\n    background-color: #ccc;\n    z-index: -1;\n}\n\n.step.active::before,\n.step.active::after {\n    background-color: #144040;\n    color: #dcca98;\n}\n\n.step-number {\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    border-radius: 50%;\n    background-color: #dcca98;\n    color: #144040;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.step.active .step-number {\n    background-color: #144040;\n    color: #dcca98;\n}\n\n.step-title {\n    font-size: 14px;\n    color: #555;\n}\n\n.step.active .step-title {\n    color: #dcca98;\n    font-weight: bold;\n}\n\n.upload-content {\n    text-align: center;\n    width: 100%;\n}\n\n.upload-content h2 {\n    margin-bottom: 10px;\n    color: #144040;\n}\n\n.upload-content p {\n    margin-bottom: 20px;\n    color: #555;\n}\n\n.file-input {\n    width: 80%;\n    padding: 12px;\n    margin: 20px 0;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n}\n\n.uploaded-file-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.uploaded-file-info p {\n    margin-bottom: 10px;\n    color: #144040;\n}\n\n.remove-file-button {\n    background-color: #d9534f;\n    color: #fff;\n    border: none;\n    padding: 8px 12px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.remove-file-button:hover {\n    background-color: #c9302c;\n}\n\n.navigation-buttons {\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    margin-top: 30px;\n}\n\n.primary-button,\n.secondary-button {\n    padding: 12px 24px;\n    border: none;\n    border-radius: 5px;\n    font-size: 1em;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.primary-button {\n    background-color: #144040;\n    color: #fff;\n}\n\n.primary-button:hover {\n    background-color: #0f2d2d;\n}\n\n.secondary-button {\n    background-color: #dcca98;\n    color: #144040;\n}\n\n.secondary-button:hover {\n    background-color: #b89e74;\n}\n\n.completion-message {\n    text-align: center;\n}\n\n.completion-message h2 {\n    color: #28a745;\n    margin-bottom: 10px;\n}\n\n.completion-message p {\n    color: #555;\n}\n\n@media (max-width: 600px) {\n    .multi-step-upload-container {\n        padding: 20px;\n    }\n\n    .file-input {\n        width: 100%;\n    }\n\n    .progress-indicator {\n        flex-direction: column;\n    }\n\n    .step:not(:last-child)::after,\n    .step:not(:first-child)::before {\n        content: none;\n    }\n\n    .step {\n        margin-bottom: 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
